// extracted by mini-css-extract-plugin
export default {"price":"V8-z","priceRow":"W8-z","onSale":"X8-z","msrpLabelPrice":"Y8-z","msrpLabel":"Z8-z","originalPrice":"_8-z","percentOff":"a9-z"};